module.exports = __webpack_public_path__ + "static/media/fa-brands-400.f6b98e39.woff";